'use client'

// React Imports
import { forwardRef } from 'react'

// Next Imports
import { Link } from 'react-router-dom'
import type { LinkProps } from 'react-router-dom'

// Type Imports
import type { ChildrenType } from '../types'

type RouterLinkProps = Omit<LinkProps, 'href' | 'to'> &
  Partial<ChildrenType> & {
    href: string
    className?: string
  }

export const RouterLink = forwardRef((props: RouterLinkProps, ref: any) => {
  // Props
  const { href, className } = props

  return (
    <Link ref={ref} to={href} className={className}>
      {props.children}
    </Link>
  )
})
